/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

interface PlayProps {
  title?: string;
}

/**
 * This is the Play component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Play({ title = 'Play' }: PlayProps) {
  return (
    <span className="svg svg-square svg-play">
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <path d="M6 19L18 12.5L6 5V19Z" fill="currentColor" />
        </svg>
      </span>
    </span>
  );
}

export default Play;
